{
    "Accessibility menu": "Pieejamības izvēlne",
    "Close": "Aizvērt",
    "Content adjustments": "Satura pielāgojumi",
    "Navigation adjustments": "Navigācijas pielāgojumi",
    "Text Align": "Teksta līdzināšana",
    "Align Left": "Izlīdzināt pa kreisi",
    "Align Center": "Līdzināt centrā",
    "Align Right": "Līdzināt pa labi",
    "Adjust Font Size": "Pielāgot fonta izmēru",
    "Highlight Title": "Izcelt virsrakstu",
    "Highlight Links": "Izcelt saites",
    "Readable Font": "Lasāms fonts",
    "Colour adjustments": "Krāsu pielāgojumi",
    "Dark Contrast": "Tumšs kontrasts",
    "Light Contrast": "Gaišs kontrasts",
    "High Contrast": "Augsts kontrasts",
    "High Saturation": "Augsts piesātinājums",
    "Low Saturation": "Zems piesātinājums",
    "Monochrome": "Vienkrāsains",
    "Tools": "Rīki",
    "Reading Guide": "Lasīšanas līnija",
    "Big Cursor": "Liels kursors",
    "Increase Font Size": "Palielināt fonta izmēru",
    "Decrease Font Size": "Samazināt fonta izmēru",
    "Letter Spacing": "Burtu atstarpes",
    "Line Height": "Rindas augstums",
    "Font Weight": "Fonta biezums",
    "Dyslexia Font": "Fonts disleksijai",
    "Language": "Valoda",
    "Accessibility widget": "Pieejamības logrīks",
    "Accessibility Profiles": "Pieejamības profili",
    "Cognitive Disability": "Kognitīvie traucējumi",
    "Seizure Safe": "Drošs pret lēkmēm",
    "Accessibility statement": "Pieejamības paziņojums",
    "ADHD": "UDHS",
    "Low Vision": "Vājredzība",
    "Pause Animations": "Apturēt animācijas",
    "Animation paused": "Animācija apturēta",
    "Reset all settings": "Atiestatīt iestatījumus",
    "Shortcut:": "Īsinājumtaustiņš:",
    "Epilepsy Safe Mode": "Epilepsijai drošs režīms",
    "Mute sounds": "Izslēgt skaņu",
    "Page read": "Lasīt lapu",
    "Page read controls": "Lapas lasīšanas vadīklas",
    "Pause": "Pauzēt",
    "Resume": "Turpināt",
    "Stop": "Apturēt",
    "Settings": "Iestatījumi",
    "Speed": "Ātrums",
    "Voice": "Balss",
    "Close accessibility menu": "Aizvērt pieejamības izvēlni",
    "Back to accessibility menu": "Atpakaļ uz pieejamības izvēlni",
    "Search languages": "Meklēt valodas",
    "Selected language": "Izvēlētā valoda",
    "View accessibility statement (opens in new window)": "Skatīt pieejamības paziņojumu (atveras jaunā logā)",
    "Visit CookieYes website (opens in new window)": "Apmeklēt CookieYes vietni (atveras jaunā logā)",
    "Reset all accessibility settings to default": "Atiestatīt visus pieejamības iestatījumus uz noklusējuma vērtībām"
}
